import * as ToastPrimitive from '@radix-ui/react-toast'
import { X } from 'lucide-react'
import { useToastStore } from '@/stores/toast-store'
import { cn } from '@/lib/utils'

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts)
  const removeToast = useToastStore((s) => s.removeToast)

  return (
    <ToastPrimitive.Provider swipeDirection="right">
      {toasts.map((t) => (
        <ToastPrimitive.Root
          key={t.id}
          open={true}
          onOpenChange={(open) => {
            if (!open) removeToast(t.id)
          }}
          duration={4000}
          className={cn(
            'flex w-80 items-start gap-3 rounded-xl border px-4 py-3',
            t.variant === 'destructive'
              ? 'border-destructive/30 bg-destructive/10'
              : 'border-border bg-card'
          )}
        >
          <div className="flex-1 space-y-0.5">
            <ToastPrimitive.Title
              className={cn(
                'text-sm font-medium',
                t.variant === 'destructive' ? 'text-destructive' : 'text-card-foreground'
              )}
            >
              {t.title}
            </ToastPrimitive.Title>
            {t.description && (
              <ToastPrimitive.Description className="text-xs text-muted-foreground">
                {t.description}
              </ToastPrimitive.Description>
            )}
          </div>
          <ToastPrimitive.Close
            onClick={() => removeToast(t.id)}
            className="mt-0.5 shrink-0 text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Tutup"
          >
            <X className="h-4 w-4" />
          </ToastPrimitive.Close>
        </ToastPrimitive.Root>
      ))}
      <ToastPrimitive.Viewport className="fixed bottom-4 right-4 z-[100] flex flex-col gap-2" />
    </ToastPrimitive.Provider>
  )
}
